import { isEmpty } from "lodash";
import { validSpecies } from "@constants/validSpecies";
import { requiredImportHeader } from "../constants/requiredImportHeader";
import { requiredRemoveHeader } from "../constants/requiredRemoveHeader";

import { defaultImportClient } from "@constants/defaultImportClient";
import { Client } from "@domain/models/Client";
import { defaultRemoveClient } from "@constants/defaultRemoveClient";
import { importCsvModel } from "@constants/importCsvModel";
import { removeCsvModel } from "@constants/removeCsvModel";
import { RemoveClient } from "@domain/models/RemoveClient";

export const csvHelper = {
  validateHeader,
  processCsv,
  validateRemoveHeader,
  processRemoveCsv,
};

function normalizeText(text: string) {
  if (text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  return text;
}

function formatCpf(cpf: string) {
  if (cpf.length != 11) {
    const zeroToAdd = 11 - cpf.length;

    let newCpf = "";

    for (let i = 0; i < zeroToAdd; i = i + 1) {
      newCpf = newCpf + "0";
    }

    newCpf = newCpf + cpf;

    if (newCpf.length == 11) {
      return newCpf;
    } else {
      return null;
    }
  } else {
    return cpf;
  }
}

function fixDDD(tel) {
  const valid = ["19", "39", "49"];

  const texto = tel.replace(/\D/g, "");

  const ddd = texto[0] + texto[1];

  const isValid = valid.find((x) => x === ddd);

  if (isValid) {
    const newDDD = 8 + texto[0];

    return `(${newDDD}) 9${texto.slice(2, texto.length - 4)}.${texto.slice(6, texto.length)}`;
  } else {
    return tel;
  }
}

function validateSpecie(especie) {
  return validSpecies.find((x) => x === especie);
}

function validateHeader(headerArray) {
  const result = {
    valid: true,
    invalidFields: [],
  };

  const invalidArray = [];

  for (const item of requiredImportHeader) {
    if (item) {
      const isValid = headerArray.find((x) => normalizeText(x) == normalizeText(item));

      if (!isValid) {
        invalidArray.push(item);
      }
    }
  }

  if (invalidArray.length > 0) {
    result["valid"] = false;
    result["invalidFields"] = invalidArray;
  }

  return result;
}

function processCsv(lines, header) {
  const errors = [];
  const array: Client[] = [];

  let lineCount = 0;

  for (const line of lines) {
    let client: Client = defaultImportClient;

    const lineColums = line.split(";");

    if (line && lineColums.length !== header.length) {
      errors.push(
        `Erro na importação! A linha "${lineCount + 1}" contém ponto e vírgula em um dos campos, remova-o para prosseguir com a importação.`
      );
      break;
    }

    for (const index in lineColums) {
      const headerNameNormalized =
        header[index] && header[index].normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      const exists = importCsvModel.find((x) => x.headerName === headerNameNormalized);

      if (exists) {
        const headerName = exists.headerName;

        const value = lineColums[index];

        if (value.includes("�")) {
          errors.push("Erro na importação! a planilha contém o símbolo não suportado �");
        }

        let addressKey: Client["validAddress"] | null = null;

        if (headerName.includes("S1")) {
          addressKey = "S1";
        }

        if (headerName.includes("S2")) {
          addressKey = "S2";
        }

        if (headerName.includes("O1")) {
          addressKey = "O1";
        }

        if (headerName.includes("O2")) {
          addressKey = "O2";
        }

        if (addressKey) {
          if (headerName.includes("ESTADO-CIDADE") && value && value != "N/D") {
            if (value.includes("-") && addressKey) {
              const arrayValue = value.split("-");

              client = {
                ...client,
                addresses: {
                  ...client.addresses,
                  [addressKey]: {
                    ...client.addresses[addressKey],
                    state: arrayValue[0].trim(),
                    city: arrayValue[1].trim(),
                  },
                },
              };

              if (!client["cityMap"] && value) {
                client = {
                  ...client,
                  cityMap: `${arrayValue[0].trim()} - ${arrayValue[1].trim()}`,
                };
              }
            } else {
              errors.push(
                "Erro na importação! a planilha não está de acordo com o padrão no campo ESTADO-CIDADE."
              );
            }
          } else {
            if (value && value != "N/D") {
              const fieldObj = importCsvModel.find((x) => x.headerName == headerName);

              client = {
                ...client,
                addresses: {
                  ...client.addresses,
                  [addressKey]: {
                    ...client.addresses[addressKey],
                    [fieldObj.field]: value,
                  },
                },
              };
            }
          }
        } else {
          const fieldObj = importCsvModel.find((x) => x.headerName == headerName);

          if (fieldObj && value) {
            const { field } = fieldObj;

            const formatedCpf = formatCpf(value);

            const formatedPrimaryTel = fixDDD(value);

            const formatedSecondaryTel = fixDDD(value);

            switch (headerName) {
              case "CPF":
                if (formatedCpf) {
                  client = {
                    ...client,
                    id: formatedCpf,
                    cpf: formatedCpf,
                  };
                } else {
                  errors.push("Erro na importação! falha na formatação dos cpfs para 11 dígitos");
                }
                break;
              case "ESPECIE":
                if (validateSpecie(value)) {
                  client = {
                    ...client,
                    specie: value,
                  };
                } else {
                  errors.push(
                    "Erro na importação! a planilha não está de acordo com o padrão na coluna 'ESPÉCIE'"
                  );
                }
                break;
              case "CELULAR":
                client = {
                  ...client,
                  phones: {
                    ...client.phones,
                    [field]: value,
                  },
                };
                break;
              case "CELULAR0":
                client = {
                  ...client,
                  phones: {
                    ...client.phones,
                    [field]: value,
                  },
                };
                break;
              case "CELULAR1":
                client = {
                  ...client,
                  phones: {
                    ...client.phones,
                    [field]: value,
                  },
                };
                break;
              case "CELULAR2":
                client = {
                  ...client,
                  phones: {
                    ...client.phones,
                    [field]: value,
                  },
                };
                break;
              case "TELEFONE PRINCIPAL":
                client = {
                  ...client,
                  telephone: {
                    ...client.telephone,
                    [field]: formatedPrimaryTel,
                  },
                };
                break;
              case "TELEFONE SECUNDARIO":
                client = {
                  ...client,
                  telephone: {
                    ...client.telephone,
                    [field]: formatedSecondaryTel,
                  },
                };
                break;
              case "TELEFONE0":
                client = {
                  ...client,
                  telephone: {
                    ...client.telephone,
                    [field]: value,
                  },
                };
                break;
              case "TELEFONE1":
                client = {
                  ...client,
                  telephone: {
                    ...client.telephone,
                    [field]: value,
                  },
                };
                break;
              case "TELEFONE2":
                client = {
                  ...client,
                  telephone: {
                    ...client.telephone,
                    [field]: value,
                  },
                };
                break;
              default:
                client[field] = value;
                break;
            }
          }
        }
      }
    }

    if (!isEmpty(client["cpf"])) {
      array.push({
        ...defaultImportClient,
        ...client,
      });
    }

    lineCount = lineCount + 1;
  }

  return {
    errors: errors,
    array: array,
  };
}

function validateRemoveHeader(headerArray) {
  const result = {
    valid: true,
    invalidFields: [],
  };

  const invalidArray = [];

  for (const item of requiredRemoveHeader) {
    if (item) {
      const isValid = headerArray.find((x) => normalizeText(x) == normalizeText(item));

      if (!isValid) {
        invalidArray.push(item);
      }
    }
  }

  if (invalidArray.length > 0) {
    result["valid"] = false;
    result["invalidFields"] = invalidArray;
  }

  return result;
}

function processRemoveCsv(lines, header) {
  const errors = [];
  const array: RemoveClient[] = [];

  for (const line of lines) {
    const client = {};

    const lineColums = line.split(";");

    for (const index in lineColums) {
      const headerName = normalizeText(header[index]);
      const value = lineColums[index];

      const fieldObj = removeCsvModel.find((x) => x.headerName == headerName);

      if (fieldObj && value) {
        const { field } = fieldObj;

        if (headerName == "CPF") {
          client[field] = formatCpf(value);
        } else {
          client[field] = value;
        }
      }
    }

    if (!isEmpty(client["id"])) {
      array.push({
        ...defaultRemoveClient,
        ...client,
      });
    }
  }

  return {
    errors: errors,
    array: array,
  };
}
